import { useMemo } from 'react';
import { formatDateDDMMYYYY } from '~/helpers/utils.ts';
import { useDocumentTypesRevoke } from './useDocumentTypesRevoke.ts';
import { getInitialDocumentType } from '../../PersonalDataApplicationSubmit/constants/applicationDocumentType.ts';
import { ApplicationRevokeFormValues, FormDataRevoke } from '../types.ts';

export interface UseFormInitialValuesRevokeReturn {
  initialValuesRevoke: ApplicationRevokeFormValues;
}

const formatOptionalDate = (value: string | Date | null | undefined) =>
  value ? formatDateDDMMYYYY(value) : null;

export const useFormInitialValuesRevoke = (
  formData?: FormDataRevoke
): UseFormInitialValuesRevokeReturn => {
  const { docType } = useDocumentTypesRevoke();

  const initialValuesRevoke = useMemo(
    (): ApplicationRevokeFormValues => ({
      lastName: formData?.lastName || null,
      firstName: formData?.firstName || null,
      middleName: formData?.middleName || null,
      identificationNumber: formData?.identificationNumber || null,
      birthDate: formatOptionalDate(formData?.birthDate),
      documentType: getInitialDocumentType(formData?.documentType, docType || undefined),
      registryRecord: formData?.registryRecord || null,
      documentSeries: formData?.documentSeries || null,
      documentNumber: formData?.documentNumber || null,
      issueDate: formatOptionalDate(formData?.issueDate),
      documentExpiryDate: formatOptionalDate(formData?.documentExpiryDate),
      issuingAuthority: formData?.issuingAuthority || null,
      financialServicesCounterpartyName: formData?.financialServices?.counterpartyName || null,
      financialServicesCounterpartyCode: formData?.financialServices?.counterpartyCode || null,
      businessRelationCounterpartyName: formData?.businessRelationship?.counterpartyName || null,
      businessRelationCounterpartyCode: formData?.businessRelationship?.counterpartyCode || null,
      disagreeWithProcessingPurpose: false,
      disagreeWithPersonalDataScope: false,
      otherReason: false,
      otherReasonDescription: null,
      atLeastOneCheckbox: false,
    }),
    [formData, docType]
  );

  return { initialValuesRevoke };
};
